import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./card_slide.css";

const CategorySlide = ({ SlideData }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    appendDots: (dots) => (
      <div
        style={{
          // backgroundColor: "black",
          borderRadius: "10px",
          padding: "10px",
        }}
        className="absolute top-0"
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
          arrows: true,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: true,
          autoplaySpeed: 3000,
          cssEase: "linear",
        },
      },
    ],
  };

  return (
    <div className="overflow-x-hidden overflow-y-hidden ">
      <Slider {...settings}>
        {SlideData?.map((item) => (
          //
          <a href={item.link} key={item.id} className="py-2">
            <div className="flex flex-col justify-center items-center gap-4">
              <div className="rounded-full w-32  h-32 bg-slate-200">
                <img
                  src={item?.img}
                  className="w-32 object-cover md:w-28 lg:w-32  h-32 rounded-full"
                  alt=""
                />
              </div>
              <p className="titlefont capitalize text-center">{item.title}</p>
            </div>
          </a>
        ))}
      </Slider>
    </div>
  );
};

export default CategorySlide;
